import React from "react";
import axios from "axios";
import { useEffect, useState } from "react";
import Header from "../header";
import Spinner from "../Spinner/Spinner";
import { Link } from "react-router-dom";
import { getEmergencyIndex } from "../../Services/emergency";
import { Player, Controls } from "@lottiefiles/react-lottie-player";

const Emergency = () => {
  const [loading, setLoading] = useState(true);
  const [activeOrderData, setActiveOrderData] = useState("");

  useEffect(() => {
    getEmergencyIndex().then((res) => {
      setLoading(false);
      setActiveOrderData(res.data.data);
    });
  }, []);
  return (
    <>
      {loading && !activeOrderData ? (
        <Spinner />
      ) : (
        <>
          <Header showSearchBar={true} title="خدمات اورژانسی" />
          <div className="emergencyMainPage">
            <Link className="emergencyLink" to={"/emergency/new-service"}>
              <span>درخواست خدمت جدید</span>
              <i className="icon-close" />
            </Link>
            <Link className="emergencyLink" to="/emergency/history">
              <span>درخواست های قبلی شما</span>
              <i className="icon-close" />
            </Link>
            {activeOrderData?.active_order?.length ? (
              <div className="currentServiceOrder">
                <div className="intro">
                  <h4>سفارش خدمت در جریان شما</h4>
                  <span>نمایش هزینه های خدمت وانتخاب خدمات اضافی</span>
                </div>
                <div className="currentServiceOrderDetails">
                  <div>
                    <span>
                      هزینه {activeOrderData.active_order?.services?.title}
                    </span>
                    <span>{activeOrderData?.price} تومان</span>
                  </div>
                </div>
                <div className="currentServiceOrderDetails">
                  <div>
                    <span>محل ارائه خدمات</span>
                    <span>{activeOrderData.active_order?.address}</span>
                  </div>
                </div>
                <div className="currentServiceOrderDetails">
                  <div>
                    <span>مشخصات تعمیرکار شما</span>
                    <span>{activeOrderData?.active_order?.garage?.name}</span>
                  </div>
                  <div>
                    <span>شماره تماس تعمیرکار شما</span>
                    <span>{activeOrderData?.active_order?.garage?.phone}</span>
                  </div>
                </div>
                {activeOrderData.active_order.extras ? (
                  <div className="currentServiceOrderDetails currentServiceOrderDetailsLast">
                    <h4>خدمات اضافی تعمیرکار</h4>
                    {activeOrderData.active_order.extras.map((item, q) => (
                      <div>
                        <span>{item.title}</span>
                        <span>{item.garage_price} تومان</span>
                      </div>
                    ))}
                  </div>
                ) : null}
                <div className="onlinePayment">پرداخت انلاین</div>
                <div className="onlinePayment">لغو</div>
              </div>
            ) : activeOrderData?.active_request ? (
              <Player
                autoplay
                loop
                src="/public/assets/img/service/serviceAnime.json"
                style={{ height: "100%", width: "90%", margin: "6rem auto 0" }}
              >
                <Controls visible={false} />
              </Player>
            ) : (
              <div className="currentServiceOrderNull">
                سفارش فعالی برای شما وجود ندارد
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default Emergency;
